import React from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import * as managePageActions from "../../../../../../store/actions/managePageActions";
import { resetManagePage } from "../../../../../../store/actions/managePageActions";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import A_Divider from "../../../../Atoms/DataDisplay/Dividers/A_Divider";
import M_ManageEntityForm from "./M_ManageEntityForm";
import DynamicIcon from "./DynamicIcon";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import PropTypes from "prop-types";
import EntityMenuCustomForms from "./EntityMenuCustomForms";

const useStyles = makeStyles((theme) => ({
  listContainer: {
    padding: theme.spacing(0.5, 1),
    "& .MuiDivider-root": {
      backgroundColor: "var(--total_row_boldbackground)",
      margin: theme.spacing(0.5, 0),
    },
  },
  listItem: {
    borderRadius: 8,
    margin: "4px 0",
    transition: "all 0.2s ease",
    color: "var(--color-text-primary)",
    "& .MuiListItemIcon-root": {
      color: "var(--color-text-secondary)",
      minWidth: 40,
      transition: "color 0.2s ease",
    },
    "& .MuiListItemText-primary": {
      fontSize: 13,
      fontWeight: 600,
    },
    "&:hover": {
      backgroundColor: "var(--total_row_background)",
      "& .MuiListItemIcon-root": {
        color: "var(--color-primary-main)",
      },
      "& .MuiListItemText-primary": {
        color: "var(--color-primary-main)",
      },
    },
  },
}));

const M_AddEntityList = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [entity, setEntity] = React.useState({});
  const [formType, setFormType] = React.useState("generic");
  const prevEntity = useSelector((state) => state.previousEntity.prevEntity);

  const handleClickOpen = (entity) => {
    if (entity?.customFormId) {
      setFormType(entity?.customFormId);
      setEntity(entity);
      setOpen(true);
      return;
    }

    if (prevEntity && prevEntity.templateId !== entity.templateId) {
      dispatch(resetManagePage());
    }
    setFormType("generic");
    setEntity(entity);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    props.onFormClose();
  };

  const filteredEntities = Array.isArray(props?.entitiesList)
    ? props.entitiesList.filter((item) => item?.name != null)
    : [];

  return (
    <>
      <List
        component="nav"
        aria-label="add entity list"
        className={classes.listContainer}
      >
        {filteredEntities.map((item, index) => (
          <React.Fragment key={index}>
            <ListItem
              button
              className={classes.listItem}
              onClick={() => handleClickOpen(item)}
            >
              <ListItemIcon>
                <DynamicIcon iconName={item.icon} />
              </ListItemIcon>
              <ListItemText primary={item.name} />
            </ListItem>
            {index !== filteredEntities.length - 1 && <A_Divider />}
          </React.Fragment>
        ))}
      </List>

      {open && formType === "generic" && (
        <M_ManageEntityForm
          fromAddEntity={true}
          entity={entity}
          open={open}
          onClose={handleClose}
          refresh={true}
        />
      )}

      {open && formType !== "generic" && (
        <EntityMenuCustomForms
          entity={entity}
          open={open}
          onClose={handleClose}
          formtypeId={formType}
        />
      )}
    </>
  );
};

M_AddEntityList.propTypes = {
  entitiesList: PropTypes.array.isRequired,
  onFormClose: PropTypes.func.isRequired,
  managePage: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    managePage: state.managePage,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(managePageActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(M_AddEntityList);
